import { type MaskOptions, parseMaskOptions } from './background-effect.ts'
import { type KeyValueStore, readStored, writeStored } from './key-value-store.ts'
import { isSegmenterModelId, type SegmenterModelId } from './segmenter-catalog.ts'

export const PROBE_PIPELINE_REVISION = 6

const OVERRIDE_KEY = 'reconforta-segmenter-override'
const MASK_KEY = 'reconforta-segmenter-mask'
const INTERVAL_KEY = 'reconforta-segmenter-interval'

export function readOverride(store: KeyValueStore | null): SegmenterModelId | null {
  const raw = readStored(store, OVERRIDE_KEY)
  return isSegmenterModelId(raw) ? raw : null
}

export function writeOverride(store: KeyValueStore | null, model: SegmenterModelId | null): void {
  writeStored(store, OVERRIDE_KEY, model)
}

export function readMaskOptions(store: KeyValueStore | null): MaskOptions | null {
  const raw = readStored(store, MASK_KEY)
  if (!raw) return null
  try {
    return parseMaskOptions(JSON.parse(raw))
  } catch {
    return null
  }
}

export function writeMaskOptions(store: KeyValueStore | null, options: MaskOptions | null): void {
  writeStored(store, MASK_KEY, options ? JSON.stringify(options) : null)
}

export const SEGMENTATION_INTERVALS = [1, 2, 3] as const

export type SegmentationInterval = (typeof SEGMENTATION_INTERVALS)[number]

export function parseSegmentationInterval(value: unknown): SegmentationInterval | null {
  const raw = typeof value === 'number' ? String(value) : value
  return SEGMENTATION_INTERVALS.find((interval) => String(interval) === raw) ?? null
}

export function readSegmentationInterval(store: KeyValueStore | null): SegmentationInterval | null {
  return parseSegmentationInterval(readStored(store, INTERVAL_KEY))
}

export function writeSegmentationInterval(
  store: KeyValueStore | null,
  value: SegmentationInterval | null,
): void {
  writeStored(store, INTERVAL_KEY, value === null ? null : String(value))
}
